'use client';

import { RecordPageViewEvent, WithAuth } from 'components/atomic/atoms';
import {
  ManagedUIContext,
  useUIContext
} from 'components/context/uiContext/ManagedUiContext';
import { Suspense, useEffect } from 'react';

const ServiceWorkerRegister = () => {
  useEffect(() => {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .getRegistration('/service-worker.js')
        .then((swRegistration) => {
          if (!swRegistration) {
            navigator.serviceWorker
              .register('/service-worker.js')
              .then((registration) => {
                console.log({
                  msg: 'WIDGET SW REGISTERED',
                  ctx: registration.scope
                });
              })
              .catch((err) => {
                console.error({
                  msg: 'WIDGET SW REGISTRATION FAILED',
                  ctx: err
                });
              });
          }
        });
    }
  }, []);

  return null;
};

const DOMContextProvider = ({ children }) => {
  const { surface, role } = useUIContext();
  return <div className={`surface-${surface} role-${role}`}>{children}</div>;
};

export function Providers({ children }) {
  return (
    <Suspense fallback={null}>
      <ManagedUIContext>
        <WithAuth>
          <DOMContextProvider>
            <RecordPageViewEvent>
              <ServiceWorkerRegister />
              {children}
            </RecordPageViewEvent>
          </DOMContextProvider>
        </WithAuth>
      </ManagedUIContext>
    </Suspense>
  );
}
